import { Component, OnInit, inject, output } from '@angular/core';
import { FormlyFieldConfig } from '@ngx-formly/core';

import { BaseEditFormComponent, FormlyService } from '../../../../tms-shared';
import { RoleService } from '../../services';

@Component({
  selector: 'app-role-details',
  templateUrl: './role-details.component.html',
  styleUrl: './role-details.component.scss',
  imports: [BaseEditFormComponent],
})
export class RoleDetailsComponent implements OnInit {
  protected readonly roleService = inject(RoleService);
  private readonly formlyService = inject(FormlyService);

  public readonly saved = output<void>();

  protected fields: FormlyFieldConfig[];

  ngOnInit() {
    this.getFields();
  }

  private getFields() {
    this.fields = this.formlyService.oneColumnGrid([
      this.formlyService.text('name', $localize`Name`, { required: true, maxLength: 256 }),
      this.formlyService.text('description', $localize`Description`, { required: true }),
      // Groups every menu option this role grants under ONE menu group with this name
      // (blank = normal menu groups). Translated server-side when the menu is built.
      this.formlyService.text('menuGroupName', $localize`Menu Group Name`, { maxLength: 100 }),
      this.formlyService.checkbox('showSettings', $localize`Show Settings`),
    ]);
  }
}
